module.exports = __webpack_public_path__ + "img/Obs_2014_logo.svg.2751478c.png";